import { IonActionSheet, IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonLoading, IonModal, IonNote, IonPage, IonRow, IonTextarea, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import BeautyStars from "beauty-stars";
import { alertCircle, arrowBack, carOutline, cardOutline, checkmarkCircle, close, cubeOutline, eye, flag, flagOutline, hourglassOutline, informationCircleOutline, locationSharp, navigateOutline, personOutline, phonePortraitOutline, receiptOutline, swapHorizontalOutline, timeOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { avaliarOperacao, requestService, urlBase } from '../../../../../Utils/Services';
import { usePhotoGallery } from '../../../../../components/usePhotoGallery';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./Acompanhar.css";
import iconHorario from "./imgs/horario.svg";
import maps from './imgs/maps.png';
import iconTempo from "./imgs/tempo.svg";
import waze from './imgs/waze.png';


type Props = {
  estabelecimento: string;
  codigoBarras: string;
  operacaoid: string;
  onDismiss: () => void;
};

const Acompanhar: React.FC<Props> = (props: Props) => {

  const location = useLocation<any>();
  const history = useHistory<any>();
  const { photos, loadPhotos } = usePhotoGallery(props.operacaoid, history);

  const [dadosOperacao, setDadosOperacao] = useState<any>([]);
  const [operacaoCarregada, setOperacaoCarregada] = useState(false);
  const [horaInicio, setHoraInicio] = useState(new Date());
  const [horaFim, setHoraFim] = useState(new Date());
  const [temHoraFim, setTemHoraFim] = useState(false);
  const [tempoOperacao, setTempoOperacao] = useState("...");
  const [showActionSheet, setShowActionSheet] = useState(false);
  const [alertConfirmar, setAlertConfirmar] = useState(false);
  const [notasAdicionais, setNotasAdicionais] = useState<any>([]);
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);
  const [valorEstrela, setValorEstrela] = useState(0);
  const [abrirAvaliar, setAbrirAvaliar] = useState(false);
  const [textoEstrela, setTextoEstrela] = useState("Selecione");
  const [comentario, setComentario] = useState("");

  const [showLoading, setShowLoading] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);

  });

  let params: any = {
    codigoBarras: "",
    estabelecimento: "",
    operacaoid: "",
  }
  params = useParams();

  if (location && location.state && location.state.operacaoid) {
    params.operacaoid = location.state.operacaoid;
  }


  if (props.operacaoid) {
    params = {
      codigoBarras: props.codigoBarras,
      estabelecimento: props.estabelecimento,
      operacaoid: props.operacaoid
    }
  }

  var estabelecimento = {
    nome: params.estabelecimento,
    parceiro: false,
    endereco: "Rua Selvin Ln, 1035, São Paulo, SP",
    horarios: [
      { dia: "segunda-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "terça-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "quarta-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "quinta-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "sexta-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "sábado", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "domingo", inicio: "8:00", fim: "16:00", aberto: false },
    ],
    medias: {
      historico: "45 min",
      hoje: "1h 30min"
    }
  }

  function tempoCorrido(horario: Date, dataFim?: Date) {
    var g = Math.ceil(((dataFim ? dataFim.getTime() : Date.now()) - horario.getTime()) / 1000 / 60);
    var tempoApurado = Math.floor(g / 60).toString() + 'h' + ('0' + (g % 60).toString()).substr(-2) + 'min';
    return tempoApurado !== "0h00min" ? tempoApurado : "0h01min";
  }

  function carregarOperacao() {
    if (params.operacaoid != "" && params.operacaoid != undefined) {
      if (!operacaoCarregada) {
        setOperacaoCarregada(true);

        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") { token = tkn; }
        console.log("operacaoid", params.operacaoid);

        const getoperacao = async () => {

          setShowLoading(true);
          const resp = await fetch(urlBase.url + "/mobile/operacao/" + params.operacaoid.replaceAll(/#/g, '%23'),
            {
              method: urlBase.method,
              headers: [
                ["token", token],
                ["perfil", window.localStorage.getItem("perfil") || ""],
                ["marca", window.localStorage.getItem("marca") || ""],
              ],
              credentials: 'include'
            });
          const operacao = await resp.json();
          //if (resp.status === 400 || resp.status === 401) history.replace("/primeiroacesso/");
          if (operacao.Item !== undefined) {
            setDadosOperacao(operacao);
            setHoraInicio(new Date(operacao.Item.dataInicio));
            setTemHoraFim(operacao.Item.dataEncerramento ? true : false);
            setHoraFim(operacao.Item.dataEncerramento ? new Date(operacao.Item.dataEncerramento) : new Date());
            setTempoOperacao(tempoCorrido(new Date(operacao.Item.dataInicio), operacao.Item.dataEncerramento ? new Date(operacao.Item.dataEncerramento) : new Date()));
            setNotasAdicionais(operacao.Item.notasAdicionais || []);

            if (operacao.Item.photo) {


              let _photos: string[] = operacao.Item.photo;
              loadPhotos(_photos);

            }

          }

          setShowLoading(false);

        }

        getoperacao();
      }
    }
    return "";
  }

  setInterval(() => setTempoOperacao(tempoCorrido(horaInicio)), 60000);

  function loadHorarios() {
    return estabelecimento.horarios.map((value, index) => {
      return (
        <div className="horario" key={index}>
          <IonLabel>{value.dia}</IonLabel>
          <IonLabel>{value.aberto ? value.inicio + " - " + value.fim : "Fechado"}</IonLabel>
        </div>);
    });

  }


  function adicionaZeroNaData(numero: any) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  function formatarDataHora(data: Date) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + ("0" + data.getHours().toString()).substr(-2) + ":" + ("0" + data.getMinutes().toString()).substr(-2);
  }

  function ajustaTextoEstrela(value: any) {
    if (value === 1) setTextoEstrela("Muito ruim");
    if (value === 2) setTextoEstrela("Ruim");
    if (value === 3) setTextoEstrela("Normal");
    if (value === 4) setTextoEstrela("Bom");
    if (value === 5) setTextoEstrela("Excelente");
  }

  function cpf_mask(v: string) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  function avaliar() {
    const atualizar = async () => {
      requestService(avaliarOperacao.url, {
        method: avaliarOperacao.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        body: JSON.stringify({
          "id": params.operacaoid,
          "avaliacao": valorEstrela + "",
          "comentario": comentario ? comentario + "" : "Sem comentário."
        }),
        credentials: 'include'
      },
        history,
        (response: any) => {
          if (response.message) {
            console.log(response);
            setAbrirAvaliar(false);
            setOperacaoCarregada(false);
            carregarOperacao();
          }
        },
        (error: any) => {
          console.log(error);
        });
    }

    if (valorEstrela !== 0) {
      setAlertaPreenchimento(false);
      atualizar();
    }
    else {
      setAlertaPreenchimento(true);
    }

  }


  return (

    <IonPage className="Acompanhar">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          {carregarOperacao()}
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonItem lines="none" color="primary" >
            <IonTitle className="ion-text-wrap" style={{ "padding-left": "20px", "padding-top": "0px", "padding-bottom": "0px", "text-align": "left" }}>Operação</IonTitle>

            <IonButton hidden={localStorage.getItem("compartilhado") == "true"}
              disabled={dadosOperacao.Item && dadosOperacao.Item.avaliacaoCliente ? dadosOperacao.Item.avaliacaoCliente : false}
              // fill='clear'
              color="tertiary"
              slot="end"
              onClick={() => {
                setAbrirAvaliar(true);

                if (dadosOperacao.Item) {
                  dadosOperacao.Item.avaliacaoCliente ? setValorEstrela(dadosOperacao.Item.avaliacaoCliente) : setValorEstrela(0);
                  setComentario(dadosOperacao.Item.comentarioCliente); console.log(dadosOperacao.Item.comentarioCliente);
                }
              }}>
              {dadosOperacao.Item && dadosOperacao.Item.avaliacaoCliente ?
                <BeautyStars size="10px"
                  value={dadosOperacao.Item.avaliacaoCliente}
                  editable={false}
                />


                : "Avaliar"}</IonButton>

          </IonItem>

        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>

        <div className="header">
          <div className="info">
            <IonIcon src={flagOutline}></IonIcon>
            <div>
              <IonLabel>Início</IonLabel>
              <IonLabel>{dadosOperacao.Item ? ("0" + new Date(dadosOperacao.Item.dataInicio).getHours().toString()).substr(-2) + ":" + ("0" +
                new Date(dadosOperacao.Item.dataInicio).getMinutes().toString()).substr(-2) : ""}</IonLabel>
            </div>
          </div>
          <div className="info">
            <IonIcon src={!temHoraFim ? hourglassOutline : flag}></IonIcon>
            <div hidden={temHoraFim}>
              <IonLabel>Em andamento</IonLabel>
              <IonLabel>{tempoOperacao}</IonLabel>
            </div>
            <div hidden={!temHoraFim}>
              <IonLabel>Término</IonLabel>
              <IonLabel>{dadosOperacao.Item ? ("0" + new Date(dadosOperacao.Item.dataEncerramento).getHours().toString()).substr(-2) + ":" + ("0" +
                new Date(dadosOperacao.Item.dataEncerramento).getMinutes().toString()).substr(-2) : ""}</IonLabel>
            </div>
          </div>
        </div>
        <IonList>
          <IonListHeader lines="full">
            <IonLabel>Operação</IonLabel>
          </IonListHeader>


          <IonItem lines="none" hidden={!(dadosOperacao.Item && dadosOperacao.Item.descricaoAgendamento)}>
            <IonIcon icon={cubeOutline} slot="start" />
            <div className="contentList">
              <h1>Descrição da operação</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.descricaoAgendamento ? dadosOperacao.Item.descricaoAgendamento : "não identificado"}</h2>
            </div>

          </IonItem>

          <IonItem lines="none">
            <IonIcon icon={swapHorizontalOutline} slot="start" />
            <div className="contentList">
              <h1>Tipo da operação</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.tipoOperacao ? dadosOperacao.Item.tipoOperacao : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon icon={informationCircleOutline} slot="start" />
            <div className="contentList">
              <h1>Status</h1>
              <h2>{dadosOperacao.Item ? dadosOperacao.Item.status : ""}</h2>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon icon={timeOutline} slot="start" />
            <div className="contentList">
              <h1>Tempo</h1>
              <div className="horario">
                <IonLabel>Início</IonLabel>
                <IonLabel>{dadosOperacao.Item ? formatarDataHora(new Date(dadosOperacao.Item.dataInicio)) : ""}</IonLabel>
              </div>
              <div className="horario">
                <IonLabel>Término</IonLabel>
                <IonLabel>{dadosOperacao.Item && dadosOperacao.Item.dataEncerramento ? formatarDataHora(new Date(dadosOperacao.Item.dataEncerramento)) : ""}</IonLabel>
              </div>
              <div className="horario">
                <IonLabel>Duração</IonLabel>
                <IonLabel>{tempoOperacao}</IonLabel>
              </div>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon icon={locationSharp} slot="start" />
            <div className="contentList">
              <h1>Endereço</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.endereco ? [dadosOperacao.Item.endereco, dadosOperacao.Item.complemento]
                .filter(Boolean)
                .join(', ') : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon src={navigateOutline} slot="start" />
            <div className="contentList">
              {(dadosOperacao.Item && dadosOperacao.Item.enderecoLat && dadosOperacao.Item.enderecoLng) ? (
                <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                  <a target='_blank' href={"https://www.google.com/maps/search/?api=1&query=" + (dadosOperacao.Item ? dadosOperacao.Item.enderecoLat + "," + dadosOperacao.Item.enderecoLng + "&query_place_id=" : "")}><img src={maps} alt="maps" /></a>
                  <a target='_blank' href={"https://waze.com/ul?ll=" + (dadosOperacao.Item ? dadosOperacao.Item.enderecoLat + "%2C" + dadosOperacao.Item.enderecoLng : "") + "&navigate=yes"}><img src={waze} alt="waze" /></a>
                </div>
              ) : (
                <h2 style={{ color: "red" }}><b>Sem Localização</b></h2>
              )}
            </div>
          </IonItem>

          {Array.isArray(notasAdicionais) && notasAdicionais.length > 0 && (
            <>
              <IonListHeader lines="full" style={{ "display": "block" }}>
                <IonLabel>Notas Fiscais</IonLabel>
              </IonListHeader>
              <IonItem lines="none" hidden={dadosOperacao.Item ? (dadosOperacao.Item.operacaoChaveAcesso === "0" ? true : false) : false}>
                <IonIcon src={receiptOutline} slot="start" />
                <div className="contentList">
                  <h1>Nota Fiscal</h1>
                  <h2>{dadosOperacao.Item ? dadosOperacao.Item.operacaoChaveAcesso.substr(25, 9) : ""} </h2>
                </div>
                <IonIcon slot="end" color="primary" src={eye} onClick={() => { window.open("https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&nfe=" + (dadosOperacao.Item ? dadosOperacao.Item.operacaoChaveAcesso : ""), '_blank') /* tipoConteudo=7PhJ+gAVw2g=& */ }} ></IonIcon>
              </IonItem>
              {notasAdicionais.map((notasValue: any, index: any) => (
                <IonItem lines="none">
                  <IonIcon src={receiptOutline} slot="start" />
                  <div className="contentList">
                    <h1>Nota Fiscal</h1>
                    <h2>{notasValue ? notasValue.notaFiscal.substr(25, 9) : ""} </h2>
                  </div>
                  <IonNote hidden={true} slot="end">{notasValue ? notasValue.tipoOperacao : ""}</IonNote>
                  <IonIcon slot="end" color="primary" src={eye} onClick={() => { window.open("http://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&nfe=" + (notasValue ? notasValue.notaFiscal : ""), '_blank')  /*window.open("http://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConteudo=XbSeqxE8pl8=&tipoConsulta=completa&nfe=" + (notasValue ? notasValue.notaFiscal : ""), '_blank')*/ }} ></IonIcon>
                </IonItem>
              ))}
            </>
          )}

          <IonListHeader lines="full">
            <IonLabel>Empresa</IonLabel>
          </IonListHeader>
          <IonItem lines="none">
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.empresaNome ? dadosOperacao.Item.empresaNome : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosOperacao.Item ? dadosOperacao.Item.empresaTelefone : "")}><h2>{dadosOperacao.Item && dadosOperacao.Item.empresaTelefone ? formataTelefone(dadosOperacao.Item.empresaTelefone) : "não identificado"}</h2></a>
              </div>
            </div>
          </IonItem>
          <IonListHeader lines="full" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonLabel>Cliente</IonLabel>
          </IonListHeader>
          <IonItem lines="none" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.clienteNome ? dadosOperacao.Item.clienteNome : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosOperacao.Item ? dadosOperacao.Item.clienteTelefone : "")}><h2>{dadosOperacao.Item && dadosOperacao.Item.clienteTelefone ? formataTelefone(dadosOperacao.Item.clienteTelefone) : "não identificado"}</h2></a>
              </div>
            </div>
          </IonItem>
          <IonListHeader lines="full">
            <IonLabel>Prestador</IonLabel>
          </IonListHeader>
          <IonItem lines="none">
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.motoristaNome ? dadosOperacao.Item.motoristaNome : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon src={cardOutline} slot="start" />
            <div className="contentList">
              <h1>CPF</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.motoristaDocumento ? cpf_mask(dadosOperacao.Item.motoristaDocumento) : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div>
                <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                  <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosOperacao.Item ? dadosOperacao.Item.motoristaTelefone : "")}><h2>{dadosOperacao.Item && dadosOperacao.Item.motoristaTelefone ? formataTelefone(dadosOperacao.Item.motoristaTelefone) : "não identificado"}</h2></a>
                </div>
              </div>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon src={carOutline} slot="start" />
            <div className="contentList">
              <h1>Veículo</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.veiculo ? dadosOperacao.Item.veiculo : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none" hidden={!(dadosOperacao.Item && dadosOperacao.Item.dataLocalizacao)}>
            <IonIcon src={navigateOutline} slot="start" />
            <div className="contentList">
              <h1>Data ultima localização</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.dataLocalizacao ? new Date(dadosOperacao.Item.dataLocalizacao).toLocaleString('pt-BR') : ""}</h2>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://www.google.com/maps/search/?api=1&query=" + (dadosOperacao.Item && dadosOperacao.Item.enderecoPrestadorLat ? dadosOperacao.Item.enderecoPrestadorLat.concat(",").concat(dadosOperacao.Item.enderecoPrestadorLng).concat("&query_place_id=") : "")}><img src={maps} alt="maps" /></a>
                <a target='_blank' href={"https://waze.com/ul?ll=" + (dadosOperacao.Item && dadosOperacao.Item.enderecoPrestadorLat ? dadosOperacao.Item.enderecoPrestadorLat.concat("%2C").concat(dadosOperacao.Item.enderecoPrestadorLng) : "") + "&navigate=yes"}><img src={waze} alt="waze" /></a>
              </div>
            </div>
          </IonItem>
          <IonItem lines="full" hidden={true}>
            <IonIcon src={iconHorario} slot="start" />
            <div className="contentList">
              <h1>Horários de Funcionamento</h1>
              {loadHorarios()}
            </div>
          </IonItem>
          <IonItem lines="full" hidden={true}>
            <IonIcon src={iconTempo} slot="start" />
            <div className="contentList">
              <h1>Tempos Médios de Carga/Descarga</h1>
              <div className="horario">
                <IonLabel>Histórico</IonLabel>
                <IonLabel>{estabelecimento.medias.historico}</IonLabel>
              </div>
              <div className="horario">
                <IonLabel>Hoje</IonLabel>
                <IonLabel>{estabelecimento.medias.hoje}</IonLabel>
              </div>
            </div>
          </IonItem>

          {Array.isArray(photos) && photos.length > 0 && (
            <>
              <IonListHeader lines="full">
                <IonLabel>Fotos da Operação</IonLabel>
              </IonListHeader>
              <IonItem lines="none">

                <IonGrid>
                  <IonRow>
                    {photos.map((photo, index) => (
                      <IonCol size="6" key={index}>
                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '0px', paddingBottom: '10px', position: 'relative' }}>
                          <div style={{ maxWidth: '350px', width: '100%', minHeight: '100px' }}>


                            <a target='_blank' href={photo.webviewpath?.replace("small", "big")}>
                              <img style={{ width: '100%', borderRadius: '5px' }} src={photo.webviewpath?.replace("small", "big")}></img>
                            </a>

                          </div>
                        </div>
                      </IonCol>
                    ))}
                  </IonRow>
                </IonGrid>

              </IonItem>
            </>
          )}
        </IonList>
        <IonActionSheet
          backdropDismiss={true}
          translucent={true}
          isOpen={showActionSheet}
          onDidDismiss={() => setShowActionSheet(false)}
          cssClass='my-custom-class'
          buttons={[{
            text: 'Encerrar Operação',
            icon: checkmarkCircle,
            handler: () => {
              setAlertConfirmar(true);
            }
          }, {
            text: 'Cancelar',
            icon: close,
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }]}
        />

        <div className="content">
          <IonModal isOpen={abrirAvaliar} className="my-custom-class Compartilhar" onDidDismiss={() => setAbrirAvaliar(false)}>
            <IonHeader className="ion-no-border">
              <IonToolbar onClick={() => setAbrirAvaliar(false)}>
                <IonTitle><span className="modal-title-text">Avaliar</span></IonTitle>
                <IonButtons slot="start">
                  <IonButton className="pedido-fluxo-back-button" aria-label="Voltar" fill="clear" ><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent>
              <div><br /></div>
              <IonItem lines="full" style={{ "margin-bottom": "20px" }}>
                <IonLabel>
                  Avalie sua operação
                </IonLabel>
                <IonIcon hidden={!alertaPreenchimento} src={alertCircle} color="danger" slot="end" />
                <IonNote hidden={!alertaPreenchimento} color="danger" slot="end" style={{ "font-size": "14px" }} >Campo obrigatório</IonNote>
              </IonItem>
              <IonItem lines="none">
                <IonLabel>Escolha de 1 a 5 estrelas para avaliar</IonLabel>

              </IonItem>
              <IonItem lines="full" style={{ "margin-bottom": "20px" }}>
                <div className="avaliarComentar">
                  <div className="avaliacaoEstrela">
                    <BeautyStars
                      value={valorEstrela}
                      onChange={value => { setAlertaPreenchimento(false); setValorEstrela(value); ajustaTextoEstrela(value); setAbrirAvaliar(true); }}
                      editable={true}
                    />
                  </div>
                </div>
              </IonItem>
              <IonItem lines="none">
                <IonLabel>
                  Deixar comentário
                </IonLabel>
              </IonItem>
              <IonItem lines="none">
                <IonTextarea rows={3}
                  value={comentario}
                  style={{ "margin": "5px", "padding": "5px", "border-width": "1px", "border-style": "solid", "border-color": "#e0e0e0", "margin-top": "10px", "margin-right": "10px", "background": "#f2f2f2" }}
                  placeholder="Conte-nos o que aconteceu (opcional)"
                  onIonChange={e => setComentario(e.detail.value!)}>
                </IonTextarea>
              </IonItem>
            </IonContent>
            <IonFooter className="ion-no-border">
              <IonToolbar >
                <IonButton expand="block" onClick={() => { avaliar() }} >Avaliar</IonButton>
              </IonToolbar>
            </IonFooter>
          </IonModal>
        </div>

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>
    </IonPage>
  );


};

export default Acompanhar;